// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards > div{
    margin-top: 15px;
    margin-bottom: 15px;
}
.cards mat-card button{
   position: absolute;
   right: 0;
   top: 0;
   display: none;
}
.cards mat-card:hover button{
    display: block;
}

.cards .card-img{
    text-align: center;
}
.cards .card-img img{
    width: 70%;
}

.cards .phone{
    color: #DA512D;
}
.cards .card-footer{
    padding-top: 8px;
    padding-bottom: 8px;
    margin: 0 -16px -16px !important;
    background-color: transparent;
}
.card-footer .companyName{
    margin: 0;
}
.cards mat-card:hover .card-footer,
.cards mat-card.active .card-footer{
    background-color: rgba(0,0,0,0.03);
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyb2tlcnMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGdCQUFnQjtJQUNoQixtQkFBbUI7QUFDdkI7QUFDQTtHQUNHLGtCQUFrQjtHQUNsQixRQUFRO0dBQ1IsTUFBTTtHQUNOLGFBQWE7QUFDaEI7QUFDQTtJQUNJLGNBQWM7QUFDbEI7O0FBRUE7SUFDSSxrQkFBa0I7QUFDdEI7QUFDQTtJQUNJLFVBQVU7QUFDZDs7QUFFQTtJQUNJLGNBQWM7QUFDbEI7QUFDQTtJQUNJLGdCQUFnQjtJQUNoQixtQkFBbUI7SUFDbkIsZ0NBQWdDO0lBQ2hDLDZCQUE2QjtBQUNqQztBQUNBO0lBQ0ksU0FBUztBQUNiO0FBQ0E7O0lBRUksa0NBQWtDO0FBQ3RDIiwiZmlsZSI6ImJyb2tlcnMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJkcyA+IGRpdntcbiAgICBtYXJnaW4tdG9wOiAxNXB4O1xuICAgIG1hcmdpbi1ib3R0b206IDE1cHg7XG59XG4uY2FyZHMgbWF0LWNhcmQgYnV0dG9ue1xuICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgcmlnaHQ6IDA7XG4gICB0b3A6IDA7XG4gICBkaXNwbGF5OiBub25lO1xufVxuLmNhcmRzIG1hdC1jYXJkOmhvdmVyIGJ1dHRvbntcbiAgICBkaXNwbGF5OiBibG9jaztcbn1cblxuLmNhcmRzIC5jYXJkLWltZ3tcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG4uY2FyZHMgLmNhcmQtaW1nIGltZ3tcbiAgICB3aWR0aDogNzAlO1xufVxuXG4uY2FyZHMgLnBob25le1xuICAgIGNvbG9yOiAjREE1MTJEO1xufVxuLmNhcmRzIC5jYXJkLWZvb3RlcntcbiAgICBwYWRkaW5nLXRvcDogOHB4O1xuICAgIHBhZGRpbmctYm90dG9tOiA4cHg7XG4gICAgbWFyZ2luOiAwIC0xNnB4IC0xNnB4ICFpbXBvcnRhbnQ7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG59XG4uY2FyZC1mb290ZXIgLmNvbXBhbnlOYW1le1xuICAgIG1hcmdpbjogMDtcbn1cbi5jYXJkcyBtYXQtY2FyZDpob3ZlciAuY2FyZC1mb290ZXIsXG4uY2FyZHMgbWF0LWNhcmQuYWN0aXZlIC5jYXJkLWZvb3RlcntcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsMCwwLDAuMDMpO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/brokers/brokers.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;GACG,kBAAkB;GAClB,QAAQ;GACR,MAAM;GACN,aAAa;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,6BAA6B;AACjC;AACA;IACI,SAAS;AACb;AACA;;IAEI,kCAAkC;AACtC;AACA,g9CAAg9C","sourcesContent":[".cards > div{\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.cards mat-card button{\n   position: absolute;\n   right: 0;\n   top: 0;\n   display: none;\n}\n.cards mat-card:hover button{\n    display: block;\n}\n\n.cards .card-img{\n    text-align: center;\n}\n.cards .card-img img{\n    width: 70%;\n}\n\n.cards .phone{\n    color: #DA512D;\n}\n.cards .card-footer{\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin: 0 -16px -16px !important;\n    background-color: transparent;\n}\n.card-footer .companyName{\n    margin: 0;\n}\n.cards mat-card:hover .card-footer,\n.cards mat-card.active .card-footer{\n    background-color: rgba(0,0,0,0.03);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
